<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout-top-main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
   <div id="content-area">
    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>
    </template>

    <template v-else>
      <the-top-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content" style="margin:10px">

            <transition :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-6 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
                  <div class="ml-auto md:block cursor-pointer">
                    <div class="vx-row">
                      <vs-checkbox v-if="selectAll" v-model="checkboxVal[0]">개강</vs-checkbox>
                      <vs-checkbox v-if="selectAll" v-model="checkboxVal[1]">종강</vs-checkbox>
                      <vs-checkbox v-if="selectAll" v-model="aloneCheckBox">개인</vs-checkbox>
                      <vs-button icon-pack="feather" icon="icon-grid" style="margin-left:5px" type="border" @click="spaceDivide()"></vs-button>
                      <vs-button icon-pack="feather" icon="icon-layout" style="margin-left:5px; margin-right:5px;" type="border" @click="spaceAll()"></vs-button>
                      <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" icon="icon-plus" @click="createSpace()"/>
                    </div>
                  </div>
                </div>
              </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer/>
    </div>
   </div>
 </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
// import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
// import TheCustomizer       from "@/layouts/components/customizer/TheCustomizer.vue"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheTopNavbarVertical   from '@/layouts/components/navbar/TheTopNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
// import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

// const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    // HNavMenu,
    // TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheTopNavbarVertical,

    // VNavMenu,
    // VxTour
  },
  data() {
    return {
      checkboxVal:[true,true],
      aloneCheckBox:false,
      selectAll: false,
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [{
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
         {
           target  : '.vs-button.buy-now',
           content : 'Buy this awesomeness at affordable price!',
           params  : {
             placement: 'top'
           }
         },
      ],
    }
  },
  watch: {
    checkboxVal(){
      if(!this.checkboxVal[0] && !this.checkboxVal[1]){
        // false, false
        this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 0)
        return
      }
      else if(this.checkboxVal[0] && !this.checkboxVal[1]){
        // true, false
        this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 1)
      }
      else if(!this.checkboxVal[0] && this.checkboxVal[1]){
        // false, true
        this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 2)
      }
      else if(this.checkboxVal[0] && this.checkboxVal[1]){
        // true, true
        this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 3)
      }
      this.aloneCheckBox = false
      this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_ALONE_STATE', this.aloneCheckBox)
    },
    aloneCheckBox(){
      if(this.aloneCheckBox){
        this.checkboxVal[0] = false
        this.checkboxVal[1] = false
        this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 0)
      }
      this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_ALONE_STATE', this.aloneCheckBox)
    },
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth }
  },
  methods: {
    createSpace() {
      this.$router.push('/pages/space/create')
    },
    spaceAll() {
      this.selectAll = true
      this.$router.push('/apps/space/all')
    },
    spaceDivide() {
      this.selectAll = false
      this.$router.push('/apps/space')
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      console.log(val)
      this.routerTransition = val
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    }
  },
  beforeCreate() {
    if (!localStorage.getItem("filleduToken") && !sessionStorage.getItem("filleduToken")) {
      this.$router.push('/pages/login')
    }
  },
  created() {
    this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_CLASS_STATE', 3)
    this.$store.commit('space/UPDATE_WORKSPACE_CHECKBOX_ALONE_STATE', this.aloneCheckBox)
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch("$store.state.windowWidth", (val) => {
      if(val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch("$store.state.verticalNavMenuWidth", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch("$vs.rtl", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy() {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
